import { Flex, Icon, Menu, MenuButton, MenuItem, MenuList, Typography } from '@aloft/toolkit-sui';

export const ValuationTablePropertyHeaderMenu = ({
  openDeleteConfirmationModal,
  openEditPropertyDetailsModal,
  isRemovable,
}: {
  openDeleteConfirmationModal: () => void;
  openEditPropertyDetailsModal: () => void;
  isRemovable: boolean;
}) => (
  <Menu placement="bottom-end" strategy="fixed">
    <MenuButton
      as={Flex}
      alignItems="center"
      justifyContent="center"
      height="24px"
      width="24px"
      minWidth="24px"
      padding="0"
    >
      <Icon icon="more-2" size="md" color="textSecondary" />
    </MenuButton>
    <MenuList minWidth="100px">
      {isRemovable && (
        <MenuItem onClick={openDeleteConfirmationModal} width="150px">
          <Typography>Delete</Typography>
        </MenuItem>
      )}
      <MenuItem onClick={openEditPropertyDetailsModal} width="150px">
        <Typography>Edit Details</Typography>
      </MenuItem>
    </MenuList>
  </Menu>
);
